/* eslint class-methods-use-this: 0 */
import {
  find, flatMapDeep, map, uniq,
} from 'lodash';
import CollectionApi from 'client/api/v2/CollectionApi';
import PolicyTemplateApi from 'client/api/v2/PolicyTemplateApi';

const allowedSearchFields = [
  'name',
];

const baseUrl = '/api/v2/providers/{id}/policygrouptemplates';

class CustomPolicyGroupTemplatesApi extends CollectionApi {
  constructor() {
    super(baseUrl, {
      skip: 0,
      limit: 10,
      sort: 'name',
      fields: [
        'name',
        'description',
        'members',
      ],
      filter: [{ name: 'name', operator: 'search', value: '' }],
      search: {
        fields: allowedSearchFields,
        searchTerm: '',
      },
    });
  }

  async fetch(skip, limit, sort, searchTerm, cancelToken, filters = []) {
    if (!this.providerId) {
      throw new Error('Missing Provider ID');
    }

    this.baseUrl = this.baseUrl.replace('{id}', this.providerId);

    const listResponse = await super.fetch(
      skip, limit, sort, searchTerm, cancelToken, filters,
    );

    let templates = [];
    if (listResponse.records) {
      templates = await this.setPolicyGroupTemplateMemberDetails(
        listResponse.records,
      );
    }

    const results = {
      totalCount: listResponse.totalCount,
      results: templates,
    };

    return results;
  }

  setProviderId(providerId) {
    this.providerId = providerId;
  }

  async setPolicyGroupTemplateMemberDetails(policyGroupTemplates) {
    // Convert all Member properties to Policies property.
    const pgTemplates = map(policyGroupTemplates, (item) => {
      const model = { ...item, policies: item.members };
      delete model.members;
      return model;
    });

    const pTemplateIds = uniq(map(flatMapDeep(pgTemplates, 'policies'), 'policyTemplateId'));
    const pTemplates = await this.getPolicyTemplatesById(pTemplateIds);

    pgTemplates.forEach((group, groupKey) => {
      group.policies.forEach((policy, policyKey) => {
        const template = find(pTemplates.results, { id: policy.policyTemplateId });

        if (template) {
          pgTemplates[groupKey].policies[policyKey] = { ...policy, template };
        }
      });
    });

    // Remove policies that don't have a template
    pgTemplates.forEach((group) => {
      group.policies.forEach((policy, policyKey) => {
        if (!policy.template) {
          group.policies.splice(policyKey, 1);
        }
      });
    });

    return pgTemplates;
  }

  async getPolicyTemplatesById(values) {
    return PolicyTemplateApi
      .findPolicyTemplatesById(values, { limit: values.length });
  }
}

export default new CustomPolicyGroupTemplatesApi();
